export const NAMESPACE_LABELS: Record<string, string> = {
  ehs: 'Health & Safety',
  crisis: 'Emergency & Crisis',
  loneworker: 'Lone Worker',
  esg: 'Sustainability',
  permits: 'Control of Work - ePermits',
  training: 'Training & eLearning',
  chemical: 'Chemical Management',
  coshh: 'Managed Chemical Risk - Sypol',
  'sds-auth': 'SDS Authoring',
  'sds-dist': 'SDS Distribution',
  // Non-products:
  platform: 'EcoOnline',
  company_admin: 'Organisation Admin',
}
